export default {
  appEnv: 'dev',
  apiUrl: `https://dev.motorcar-tuning.shop/api/`,
  downloadUrl: `https://dev.motorcar-tuning.shop/`,
};
